export type TreeOption = { label: string; value: string; children?: TreeOption[] };

export const CONTACT_CHILDREN: TreeOption[] = [
  { label: "Full Name", value: "{{contact.name}}" },
  { label: "First Name", value: "{{contact.first_name}}" },
  { label: "Last Name", value: "{{contact.last_name}}" },
  { label: "Email", value: "{{contact.email}}" },
  { label: "Phone", value: "{{contact.phone}}" },
  { label: "Company Name", value: "{{contact.company_name}}" },
  { label: "Full Address", value: "{{contact.full_address}}" },
  { label: "Address 1", value: "{{contact.address1}}" },
  { label: "City", value: "{{contact.city}}" },
  { label: "State", value: "{{contact.state}}" },
  { label: "Country", value: "{{contact.country}}" },
  { label: "Postal Code", value: "{{contact.postal_code}}" },
  { label: "Date of birth", value: "{{contact.date_of_birth}}" },
  { label: "Source", value: "{{contact.source}}" },
  { label: "Website", value: "{{contact.website}}" },
  { label: "ID", value: "{{contact.id}}" },
];

export const RIGHT_NOW_CHILDREN: TreeOption[] = [
  { label: "Second", value: "{{right_now.second}}" },
  { label: "Minute", value: "{{right_now.minute}}" },
  { label: "Hour 24h format", value: "{{right_now.hour}}" },
  { label: "Hour AM/PM format", value: "{{right_now.hour_ampm}}" },
  { label: "Time 24h format", value: "{{right_now.time}}" },
  { label: "Time AM/PM format", value: "{{right_now.time_ampm}}" },
  { label: "AM/PM", value: "{{right_now.ampm}}" },
  { label: "Day", value: "{{right_now.day}}" },
  { label: "Day of the week extended English", value: "{{right_now.day_of_week}}" },
  { label: "Month", value: "{{right_now.month}}" },
  { label: "Month extended English", value: "{{right_now.month_english}}" },
  { label: "Year", value: "{{right_now.year}}" },
  { label: "Date (month/day/year)", value: "{{right_now.middle_endian_date}}" },
  { label: "Date (day/month/year)", value: "{{right_now.little_endian_date}}" },
];
